import React, { Component } from "react";
import "../styles/style.css";
import MultiSelectInput from "./MultiSelectInput";

interface AlbumTagProps {
  organizationId: number;
  albumName: String;
  photosCount: number;
  appliedTags: Array<{ name: string; tagId: number }>;
  contentTagsAPI: string;
  albumId: number;
  onClose?: () => void;
}

class AlbumTag extends Component<AlbumTagProps> {
  handleClose = () => {
    if (this.props.onClose) {
      this.props.onClose();
    } else {
      // Fallback to DOM manipulation if onClose prop not provided
      var tagPopupContainer = document.querySelector(".tag-popup-container");
      //@ts-ignore
      tagPopupContainer.style.display = "none";
    }
  };

  render() {
    return (
      <div>
        <div
          id="album-tag-modal-dialog"
          className="modal fade in geo-modal geo-modal--small geo-modal--scroll"
          role="dialog"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              
              <div className="modal-header">
                <h5 className="modal-title">Add tags to album</h5>
                <button className="close" onClick={() => this.handleClose()}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="album-modal-sub">
                  All the photos in this album will have these tags by default
                </div>
                <div className="album-name-div">
                  <span className="album-modal-head head-2-font">
                    {this.props.albumName}
                  </span>
                  <span className="album-modal-sub sub-2-font">
                    {this.props.photosCount} photos
                  </span>
                </div>
                <MultiSelectInput
                  appliedTags={this.props.appliedTags}
                  contentTagsAPI={this.props.contentTagsAPI}
                  handleClose={this.handleClose}
                  tagType={"album"}
                  reloadPage={true}
                  albumId={this.props.albumId}
                />
              </div>
            
            </div>
          </div>
        </div>{" "}
        <div className="modal-backdrop fade in" />
      </div>
    );
  }
}

export default AlbumTag;
